import { TextField, type TextFieldProps } from './text-field';

export interface LabeledTextFieldProps extends TextFieldProps {
  label: string | React.ReactNode;
}

/**
 * A TextField that always renders a visible label.
 */
export const LabeledTextField = (props: LabeledTextFieldProps) => (
  <TextField {...props} />
);
